<template>
  <HKLTabs
    :defaultActiveKey="1"
    class="guideline-tabs-outer"
  >
    <template v-for="(tab) in tabArray">
      <a-tab-pane
        :key="tab.tabId"
        :tab="tab.tabName"
      >
        <HkldLetter
          :id="`guideline_${tab.tabType}`"
          :ref="tab.tabType"
          :type="tab.tabType"
          :isLineOrderEditable="tab.isLineOrderEditable"
          :validateDuplicate="tab.validateDuplicate"
          :resetDuplicate="tab.resetDuplicate"
          :publishHint="tab.publishHint"
          :onlyLine="tab.onlyLine"
        />
      </a-tab-pane>
    </template>
  </HKLTabs>
</template>

<script>
import HkldLetter from './HkldLetter'
import { GUIDELINE_TYPE } from '@/modules/settings/engineers/consts'
import HKLTabs from '@/controls/Tab/HKLTabs'
import i18n from '@/utils/i18n'
import { computed, unref } from 'vue-demi'
import { useStoreGetters } from '@/store'

export default {
  name: 'GuidelineSetting',
  components: {
    HkldLetter,
    HKLTabs,
  },
  setup () {
    const regionStore = useStoreGetters('regions', ['enableGreenFitOutFeature', 'enableGreenOperationFeature'])
    const findDuplicatedIndexOfArr = (array) => {
      let rep = new Set()
      array.forEach((item, index) => {
        if (array.indexOf(item) !== index) {
          rep.add(array.indexOf(item))
          rep.add(index)
        }
      })
      return Array.from(rep)
    }
    const validateDuplicate = (guidelines) => {
      const sectionArr = []
      const lineObj = {}
      guidelines.forEach((section, index) => {
        sectionArr.push(`${section.displayOrder} ${section.value}`)
        lineObj[index] = section.sectionContent.map(line => `${line.displayOrder} ${line.value}`)
      })
      const sectionDupIndexes = findDuplicatedIndexOfArr(sectionArr)
      let lineDupIndexes = {}
      Object.keys(lineObj).map((key) => {
        const arr = findDuplicatedIndexOfArr(lineObj[key])
        arr.length ? lineDupIndexes[key] = arr : ''
      })
      sectionDupIndexes.map(secIndex => {
        guidelines[secIndex].class = 'duplicated-group'
      })
      Object.keys(lineDupIndexes).map(secIndex => {
        lineDupIndexes[secIndex].map(lineIndex => {
          guidelines[secIndex].sectionContent[lineIndex].class = 'duplicated-group'
        })
      })
      return sectionDupIndexes.length || Object.keys(lineDupIndexes).length
    }
    const resetDuplicate = (guidelines) => {
      guidelines.forEach((section, secIndex) => {
        if (section.class) {
          guidelines[secIndex].class = undefined
        }
        section.sectionContent.forEach((line, lineIndex) => {
          if (line.class) {
            guidelines[secIndex].sectionContent[lineIndex].class = undefined
          }
        })
      })
    }
    const tabArray = computed(() => {
      const result = [{
        tabId: 1,
        tabType: GUIDELINE_TYPE.FITOUT_LETTER,
        tabName: i18n.t(`settings.TenantProjectGuideline.FitoutLetter`),
        isLineOrderEditable: false,
        publishHint: i18n.t('guideline.publishGuideline'),
      }, {
        tabId: 2,
        tabType: GUIDELINE_TYPE.POST_FITOUT_LETTER,
        tabName: i18n.t(`settings.TenantProjectGuideline.PostFitoutLetter`),
        isLineOrderEditable: false,
        publishHint: i18n.t('guideline.publishGuideline'),
      }, {
        tabId: 3,
        tabType: GUIDELINE_TYPE.REINSTATEMENT_LETTER,
        tabName: i18n.t(`settings.TenantProjectGuideline.reinstatementLetter`),
        isLineOrderEditable: false,
        publishHint: i18n.t('guideline.publishGuideline'),
      }]
      if (unref(regionStore.enableGreenFitOutFeature)) {
        result.push({
          tabId: 4,
          tabType: GUIDELINE_TYPE.GREEN_FITOUT,
          tabName: i18n.t(`settings.TenantProjectGuideline.greenFitout`),
          isLineOrderEditable: false,
          publishHint: i18n.t('guideline.publishGuideline'),
        }, {
          tabId: 5,
          tabType: GUIDELINE_TYPE.GREEN_FITOUT_FOLDER,
          tabName: i18n.t(`settings.TenantProjectGuideline.greenFitoutFolder`),
          isLineOrderEditable: true,
          validateDuplicate: validateDuplicate,
          resetDuplicate: resetDuplicate,
          publishHint: i18n.t('guideline.publishFolder'),
        })
      }
      if (unref(regionStore.enableGreenOperationFeature)) {
        result.push({
          tabId: 6,
          tabType: GUIDELINE_TYPE.GREEN_OPERATION,
          tabName: i18n.t(`settings.TenantProjectGuideline.greenOperation`),
          isLineOrderEditable: false,
          publishHint: i18n.t('guideline.publishGuideline'),
        })
      }
      result.push({
        tabId: 7,
        tabType: GUIDELINE_TYPE.FINAL_DOCUMENT_FOLDER,
        tabName: i18n.t(`settings.TenantProjectGuideline.finalDocumentFolder`),
        isLineOrderEditable: false,
        publishHint: i18n.t('guideline.publishFolder'),
        onlyLine: true,
      })
      return result
    })
    return {
      ...regionStore,
      tabArray,
    }
  },
}
</script>

<style scoped>
.guideline-tabs-outer {
  overflow: unset;
}
</style>
